/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import TextInput from "../../../../../Basis/Components/TextInput";
import AendereEigeneFirmendaten, { AendereEigeneFirmendatenInput } from "../../../../../Management/Mandanten/Commands/AendereEigeneFirmendaten";
import LandInput from "../../../../../Shared/Countries/Components/LandInput";
import RegionInput from "../../../../../Shared/Countries/Components/RegionInput";
import { translationKeys, useTranslation } from "../../../Internationalisierung/i18nEinstellungen";
import { FirmendatenName } from "./types";

type ChangeHandler = <Key extends FirmendatenName>(k: Key) => (v: AendereEigeneFirmendatenInput[Key]) => void;

type FirmendatenInputProps = {
    name: FirmendatenName;
    data: AendereEigeneFirmendatenInput;
    onChange: ChangeHandler;
    autoFocus?: boolean;
    required?: boolean;
}

export default function FirmendatenInput({ name, data, autoFocus, onChange, required }: FirmendatenInputProps) {
    const { t } = useTranslation();
    if (name === "land" || name === "rechnungsadresseLand") {
        return (
            <LandInput
                caption={t(translationKeys.firmendatenInput[name])}
                value={data[name]}
                onChange={onChange(name)}
                typBezeichnung={AendereEigeneFirmendaten.commandName}
                feldBezeichnung={name}
                autoFocus={autoFocus}
                required={required}
                isGermanTranslation
            />
        );
    }

    if (name === "region" || name === "rechnungsadresseRegion") {
        return (
            <RegionInput
                caption={t(translationKeys.firmendatenInput[name])}
                value={data[name]}
                onChange={onChange(name)}
                typBezeichnung={AendereEigeneFirmendaten.commandName}
                feldBezeichnung={name}
                autoFocus={autoFocus}
                landIso={name === "region" ? data.land : data.rechnungsadresseLand}
                required={required}
                isGermanTranslation
            />
        );
    }

    return (
        <TextInput
            caption={t(translationKeys.firmendatenInput[name])}
            value={data[name]}
            onChange={e => onChange(name)(e.target.value)}
            typBezeichnung={AendereEigeneFirmendaten.commandName}
            feldBezeichnung={name}
            autoFocus={autoFocus}
            required={required}
        />
    );
}